// import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// interface DashBoardState {
//   dashboardData: any[];
//   loading: boolean;
//   error: string | null;
// }

// const initialState: DashBoardState = {
//   dashboardData: [],
//   loading: false,
//   error: null,
// };

// const dashboardSlice = createSlice({
//   name: 'dashboard',
//   initialState,
//   reducers: {
//     setDashboardData(state, action: PayloadAction<any[]>) {
//       state.dashboardData = action.payload;
//       state.error = null; // Clear error on success
//     },
//     setLoading(state, action: PayloadAction<boolean>) {
//       state.loading = action.payload;
//     },
//     setError(state, action: PayloadAction<string>) {
//       state.error = action.payload;
//     },
//   },
// });

// export const { setDashboardData, setLoading, setError } = dashboardSlice.actions;
// export default dashboardSlice.reducer;

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashBoardState {
  dashboard: {
    dashboardData: any[];
    dashboardSpData: any[];
    dashboardCriticalData: any[];
    dashboardSOPOData: any[];
    dashboardCashAndBankData: any[];
    dashboardAmountPayData: any[];
    dashboardAmountRecData: any[];
    dashboardExpenseCardData: any[];
  };
  loading: boolean;
  error: string | null;
  edgeStatus: {
    pendingRequestKeys: string[];
    errorCode: string | null;
    errorMessage: string | null;
    lastSuccessUtc: string | null;
  };
}

const initialState: DashBoardState = {
  dashboard: {
    dashboardData: [],
    dashboardSpData: [],
    dashboardCriticalData: [],
    dashboardSOPOData: [],
    dashboardCashAndBankData: [],
    dashboardAmountPayData: [],
    dashboardAmountRecData: [],
    dashboardExpenseCardData: [],
  },
  loading: false,
  error: null,
  edgeStatus: {
    pendingRequestKeys: [],
    errorCode: null,
    errorMessage: null,
    lastSuccessUtc: null,
  },
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardData = action.payload;
      state.error = null;
    },
    setDashboardSpData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardSpData = action.payload;
      state.error = null;
    },
    setDashboardCriticalData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardCriticalData = action.payload;
      state.error = null;
    },
    setDashboardSOPOData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardSOPOData = action.payload;
      state.error = null;
    },
    setDashboardCashAndBankData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardCashAndBankData = action.payload;
      state.error = null;
    },
    setDashboardAmountPayData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountPayData = action.payload;
      state.error = null;
    },
    setDashboardAmountRecData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountRecData = action.payload;
      state.error = null;
    },
    setDashExpenseCardData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardExpenseCardData = action.payload;
      state.error = null;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    edgeRequestStarted(state, action: PayloadAction<string>) {
      if (state.edgeStatus.pendingRequestKeys.length === 0) {
        state.edgeStatus.errorCode = null;
        state.edgeStatus.errorMessage = null;
      }
      if (!state.edgeStatus.pendingRequestKeys.includes(action.payload)) {
        state.edgeStatus.pendingRequestKeys.push(action.payload);
      }
    },
    edgeRequestSucceeded(
      state,
      action: PayloadAction<{ requestKey: string; completedAtUtc: string }>
    ) {
      state.edgeStatus.pendingRequestKeys = state.edgeStatus.pendingRequestKeys.filter(
        (key) => key !== action.payload.requestKey
      );
      state.edgeStatus.lastSuccessUtc = action.payload.completedAtUtc;
    },
    edgeRequestFailed(
      state,
      action: PayloadAction<{
        requestKey: string;
        errorCode: string;
        errorMessage: string;
      }>
    ) {
      state.edgeStatus.pendingRequestKeys = state.edgeStatus.pendingRequestKeys.filter(
        (key) => key !== action.payload.requestKey
      );
      state.edgeStatus.errorCode = action.payload.errorCode;
      state.edgeStatus.errorMessage = action.payload.errorMessage;
    },
    clearEdgeDashboardError(state) {
      state.edgeStatus.errorCode = null;
      state.edgeStatus.errorMessage = null;
    },
  },
});

export const {
  setDashboardData,
  setDashboardSpData,
  setDashboardCriticalData,
  setDashboardSOPOData,
  setDashboardCashAndBankData,
  setDashboardAmountPayData,
  setDashboardAmountRecData,
  setDashExpenseCardData,
  setLoading,
  setError,
  edgeRequestStarted,
  edgeRequestSucceeded,
  edgeRequestFailed,
  clearEdgeDashboardError,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
